import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SITE_CONTENT } from "../content";

const SocialIcon = ({ icon }) => {
  const icons = {
    facebook: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
      </svg>
    ),
    twitter: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
      </svg>
    ),
    linkedin: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
      </svg>
    ),
    instagram: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.186 0 12 0 12s0 3.814.501 5.814a3.016 3.016 0 0 0 2.122 2.136c1.872.55 9.377.55 9.377.55s7.505 0 9.377-.55a3.016 3.016 0 0 0 2.122-2.136C24 15.814 24 12 24 12s0-3.814-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  };
  return icons[icon] || null;
};

const Header = () => {
  const { global } = SITE_CONTENT;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [orderDropdownOpen, setOrderDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="rest-header">
      {/* === TOP INFO BAR === */}
      <div className="rest-topbar">
        <div className="rest-topbar-inner">
          <div className="rest-topbar-left">
            <span className="rest-topbar-item">
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="13"
                height="13"
              >
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </svg>
              New market Sandigo - California
            </span>
            <span className="rest-topbar-separator">/</span>
            <span className="rest-topbar-item">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                width="13"
                height="13"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              9.00 am - 5.00 pm
            </span>
            <span className="rest-topbar-separator">/</span>
            <span className="rest-topbar-item rest-halal-badge">
              <svg
                viewBox="0 0 100 100"
                width="14"
                height="14"
                fill="currentColor"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="6"
                />
                <text
                  x="50"
                  y="55"
                  fontSize="26"
                  fontWeight="bold"
                  textAnchor="middle"
                  fill="currentColor"
                >
                  حلال
                </text>
                <text
                  x="50"
                  y="80"
                  fontSize="16"
                  fontWeight="bold"
                  textAnchor="middle"
                  fill="currentColor"
                >
                  HALAL
                </text>
              </svg>
              100% Halal Certified
            </span>
          </div>

          <div className="rest-topbar-right">
            <span className="follow-us-text">Follow Us:</span>
            <div className="rest-topbar-socials">
              {global.topBar.socials.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="rest-social-icon"
                  aria-label={s.icon}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SocialIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* === LOGO + NAV ROW === */}
      <div className={`rest-navbar${scrolled ? " rest-navbar--scrolled" : ""}`}>
        <div className="rest-navbar-inner">
          {/* Custom Styled Logo matching FRESHEAT layout from screenshot but branded for FLAKES */}
          <Link to="/" className="rest-logo-block">
            <div className="rest-logo-text-wrap">
              <div className="rest-logo-line-top" />
              <span className="rest-logo-brand">FLAKES</span>
              <div className="rest-logo-line-middle" />
              <span className="rest-logo-subtitle">FRIED CHICKEN</span>
              <div className="rest-logo-line-bottom" />
            </div>
            <div className="rest-logo-icon">
              {/* Cloche cover hand icon */}
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="36"
                height="36"
              >
                <path d="M12 5V3M10 3h4" />
                <path d="M4 14a8 8 0 0 1 16 0" />
                <path d="M2 15h20" />
                <path d="M16 18c-2 2-3 2-6 2H4a1 1 0 0 1-1-1v-1" />
                <path d="M19 18a2 2 0 0 0 2-2v-1" />
              </svg>
            </div>
          </Link>

          {/* Center Nav Menu with Dropdowns */}
          <nav className="rest-nav-menu" aria-label="Main navigation">
            <div className="rest-nav-item">
              <Link to="/" className="rest-nav-link-new">
                Home
                <svg
                  className="chevron-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  width="10"
                  height="10"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </Link>
              <div className="rest-dropdown-menu">
                <Link to="/" className="rest-dropdown-item-new">
                  Main Home
                </Link>
                <a href="/#menu" className="rest-dropdown-item-new">
                  Menu Section
                </a>
              </div>
            </div>

            <div className="rest-nav-item">
              <span className="rest-nav-link-new">
                Pages
                <svg
                  className="chevron-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  width="10"
                  height="10"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              <div className="rest-dropdown-menu">
                <a href="/#about" className="rest-dropdown-item-new">
                  About Us
                </a>
                <a href="/#why" className="rest-dropdown-item-new">
                  Why FFC
                </a>
                <a href="/#testimonials" className="rest-dropdown-item-new">
                  Reviews
                </a>
              </div>
            </div>

            <div className="rest-nav-item">
              <Link to="/menu" className="rest-nav-link-new">
                Food Menu
                <svg
                  className="chevron-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  width="10"
                  height="10"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </Link>
              <div className="rest-dropdown-menu">
                <Link
                  to="/menu#Fried Chicken"
                  className="rest-dropdown-item-new"
                >
                  Crispy Fried Chicken
                </Link>
                <Link
                  to="/menu#All in One flakesfriedchickens"
                  className="rest-dropdown-item-new"
                >
                  FFC flakesfriedchickens
                </Link>
                <Link to="/menu#Mini Bites" className="rest-dropdown-item-new">
                  Sides & Drinks
                </Link>
              </div>
            </div>

            <div className="rest-nav-item">
              <Link to="/blog" className="rest-nav-link-new">
                Blog
                <svg
                  className="chevron-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  width="10"
                  height="10"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </Link>
              <div className="rest-dropdown-menu">
                <Link to="/blog" className="rest-dropdown-item-new">
                  Latest News
                </Link>
                <Link to="/blog" className="rest-dropdown-item-new">
                  Crispy Stories
                </Link>
              </div>
            </div>

            <div className="rest-nav-item">
              <span className="rest-nav-link-new">
                Shop
                <svg
                  className="chevron-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  width="10"
                  height="10"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              <div className="rest-dropdown-menu">
                <a
                  href={global.orderLocations?.Salem?.swiggy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rest-dropdown-item-new"
                >
                  Salem Swiggy
                </a>
                <a
                  href={global.orderLocations?.Coimbatore?.swiggy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rest-dropdown-item-new"
                >
                  Coimbatore Swiggy
                </a>
              </div>
            </div>

            <div className="rest-nav-item">
              <Link to="/contact" className="rest-nav-link-new">
                Contact
                <svg
                  className="chevron-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  width="10"
                  height="10"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </Link>
              <div className="rest-dropdown-menu">
                <Link to="/contact" className="rest-dropdown-item-new">
                  Branches
                </Link>
                <Link to="/contact" className="rest-dropdown-item-new">
                  Contact Us
                </Link>
              </div>
            </div>
          </nav>

          {/* Right Actions */}
          <div className="rest-nav-actions">
            <button className="rest-search-btn" aria-label="Search">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                width="20"
                height="20"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>

            {/* ORDER NOW button with dropdown for Salem / Coimbatore locations */}
            <div
              className="rest-order-dropdown-wrap"
              onMouseEnter={() => setOrderDropdownOpen(true)}
              onMouseLeave={() => setOrderDropdownOpen(false)}
            >
              <button className="rest-order-button-new" aria-label="Order Now">
                <span className="btn-text">ORDER NOW</span>
                <div className="btn-arrow-box">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    width="12"
                    height="12"
                  >
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </div>
              </button>

              {orderDropdownOpen && (
                <div className="rest-order-dropdown">
                  <div className="rest-order-dropdown-title">
                    SELECT LOCATION
                  </div>

                  <a
                    href={global.orderLocations?.Salem?.swiggy}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rest-order-dropdown-item rest-order-swiggy"
                  >
                    Salem Swiggy 🛵
                  </a>
                  <a
                    href={global.orderLocations?.Salem?.zomato}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rest-order-dropdown-item rest-order-zomato"
                  >
                    Salem Zomato 🍴
                  </a>
                  <a
                    href={global.orderLocations?.Coimbatore?.swiggy}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rest-order-dropdown-item rest-order-swiggy"
                  >
                    Coimbatore Swiggy 🛵
                  </a>
                  <a
                    href={global.orderLocations?.Coimbatore?.zomato}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rest-order-dropdown-item rest-order-zomato"
                  >
                    Coimbatore Zomato 🍴
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu trigger (hamburger) */}
          <button
            className={`rest-mobile-menu-trigger${mobileMenuOpen ? " active" : ""}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="line" />
            <span className="line" />
            <span className="line" />
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {mobileMenuOpen && (
          <div className="rest-mobile-nav">
            <div className="rest-mobile-nav-item">
              <Link
                to="/"
                className="rest-mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
            </div>

            <div className="rest-mobile-nav-item">
              <span className="rest-mobile-nav-link">Pages</span>
              <div className="rest-mobile-subitems">
                <a
                  href="/#about"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  About Us
                </a>
                <a
                  href="/#why"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Why FFC
                </a>
                <a
                  href="/#testimonials"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Reviews
                </a>
              </div>
            </div>

            <div className="rest-mobile-nav-item">
              <Link
                to="/menu"
                className="rest-mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Food Menu
              </Link>
              <div className="rest-mobile-subitems">
                <Link
                  to="/menu#Fried Chicken"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Crispy Chicken
                </Link>
                <Link
                  to="/menu#All in One flakesfriedchickens"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  FFC flakesfriedchickens
                </Link>
                <Link
                  to="/menu#Mini Bites"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Sides & Drinks
                </Link>
              </div>
            </div>

            <div className="rest-mobile-nav-item">
              <Link
                to="/blog"
                className="rest-mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
              <div className="rest-mobile-subitems">
                <Link
                  to="/blog"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Latest News
                </Link>
                <Link
                  to="/blog"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Crispy Stories
                </Link>
              </div>
            </div>

            <div className="rest-mobile-nav-item">
              <span className="rest-mobile-nav-link">Shop</span>
              <div className="rest-mobile-subitems">
                <a
                  href={global.orderLocations?.Salem?.swiggy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Salem Delivery
                </a>
                <a
                  href={global.orderLocations?.Coimbatore?.swiggy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Coimbatore Delivery
                </a>
              </div>
            </div>

            <div className="rest-mobile-nav-item">
              <Link
                to="/contact"
                className="rest-mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <div className="rest-mobile-subitems">
                <Link
                  to="/contact"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Branches
                </Link>
                <Link
                  to="/contact"
                  className="rest-mobile-subitem"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact Us
                </Link>
              </div>
            </div>

            {/* Mobile Order CTAs */}
            <div className="rest-mobile-actions">
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#888",
                  letterSpacing: "1.2px",
                  marginBottom: "4px",
                  textTransform: "uppercase",
                }}
              >
                ORDER ONLINE
              </div>
              <a
                href={global.orderLocations?.Salem?.swiggy}
                target="_blank"
                rel="noopener noreferrer"
                className="rest-mobile-order rest-mobile-order-swiggy"
                onClick={() => setMobileMenuOpen(false)}
              >
                Salem Swiggy 🛵
              </a>
              <a
                href={global.orderLocations?.Salem?.zomato}
                target="_blank"
                rel="noopener noreferrer"
                className="rest-mobile-order rest-mobile-order-zomato"
                onClick={() => setMobileMenuOpen(false)}
              >
                Salem Zomato 🍴
              </a>
              <a
                href={global.orderLocations?.Coimbatore?.swiggy}
                target="_blank"
                rel="noopener noreferrer"
                className="rest-mobile-order rest-mobile-order-swiggy"
                onClick={() => setMobileMenuOpen(false)}
              >
                Coimbatore Swiggy 🛵
              </a>
              <a
                href={global.orderLocations?.Coimbatore?.zomato}
                target="_blank"
                rel="noopener noreferrer"
                className="rest-mobile-order rest-mobile-order-zomato"
                onClick={() => setMobileMenuOpen(false)}
              >
                Coimbatore Zomato 🍴
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
